import { authorization } from 'Module/Auth/Auth'
import { useWrappedPosthog } from 'Components/PostHogProvider/hooks'
import { AnalyticsEventEmitter } from 'Utils/Analytics/AnalyticsEventEmitter'
import { CAMPAIGN_TYPE_PARAM_TO_CHANNEL } from 'shared/constants'

const usePosthogAnalyticsD2D = () => {
  const posthog = useWrappedPosthog()

  const emitAnalyticsEvent = () => {
    const user = authorization.getUser()
    const eventEmitter = new AnalyticsEventEmitter(posthog)
    eventEmitter.run({
      eventName: 'Clicked on CTA campaign empty state page',
      userId: user.id,
      clientName: user.client.name,
      additionalPayload: {
        channel: CAMPAIGN_TYPE_PARAM_TO_CHANNEL['d2d'],
      },
    })
  }

  return { emitAnalyticsEvent }
}

export default usePosthogAnalyticsD2D
